import { useState } from 'react';

export function useListEditor(onClear) {
  const [editIndex, setEditIndex] = useState(null);

  const clear = () => {
    setEditIndex(null);
    onClear?.();
  };

  const select = (i) => setEditIndex(i);

  return { editIndex, select, clear, isEditing: editIndex !== null };
}
